export default "<app-equation [data]=\"equation\"></app-equation>\n<app-answer-check-button [task]=\"task\"></app-answer-check-button>\n"